export const LISTITEMS: any[] = [
    { 'url': '/dashboard', 'name': 'Page', 'icon': 'ft-home' },
    { 'url': '/auth/login', 'name': 'Login', 'icon': 'ft-log-in' },
];

